import React from "react"
import { UsaStates } from "content/UsaStateOptions"
import { CompleteFormSelect, FormSelectProps } from "components/views/atoms/forms/FormSelect"
import { CompleteFormElementProps } from "components/views/atoms/forms/completeFormElementFactory"

type CompleteUsaStateSelectProps = CompleteFormElementProps<HTMLSelectElement> & Omit<FormSelectProps, "options">

const CompleteUsaStateSelect = React.forwardRef<HTMLSelectElement, CompleteUsaStateSelectProps>(({ ...props }, ref) => (
  <CompleteFormSelect {...props} ref={ref} options={UsaStates} />
))

CompleteUsaStateSelect.displayName = "CompleteUsaStateSelect"

export { CompleteUsaStateSelect }
